import { Injectable } from '@angular/core';
import { TicketModel } from '../../models';
import { SmoochSdkFacade } from '../smooch-sdk-facade/smooch-sdk-facade.service';

@Injectable()
export class SupportRequestService {
  constructor(private smooch: SmoochSdkFacade) {}

  openTicketAsync(ticket: TicketModel): void {
    this.smooch.open(`${ticket.subject}\n${ticket.description}`);
  }
}
